export default "__VITE_ASSET__Dk_tr_Iy__"